/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  KillswitchCapabilityKey,
  KillswitchCapabilityKey$inboundSchema,
} from "./killswitchcapabilitykey.js";
import {
  KillswitchSchedule,
  KillswitchSchedule$inboundSchema,
} from "./killswitchschedule.js";
import {
  KillswitchScope,
  KillswitchScope$inboundSchema,
} from "./killswitchscope.js";
import {
  KillswitchStatus,
  KillswitchStatus$inboundSchema,
} from "./killswitchstatus.js";

export type KillswitchSummary = {
  capabilityLabel: string;
  id: string;
  schedule: KillswitchSchedule;
  scope: KillswitchScope;
  userId: string;
  version: number;
  capabilityKey: KillswitchCapabilityKey;
  status: KillswitchStatus;
};

/** @internal */
export const KillswitchSummary$inboundSchema: z.ZodMiniType<
  KillswitchSummary,
  unknown
> = z.pipe(
  z.object({
    capability_label: z.string(),
    id: z.string(),
    schedule: KillswitchSchedule$inboundSchema,
    scope: KillswitchScope$inboundSchema,
    user_id: z.string(),
    version: z.int(),
    capability_key: KillswitchCapabilityKey$inboundSchema,
    status: KillswitchStatus$inboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      "capability_label": "capabilityLabel",
      "user_id": "userId",
      "capability_key": "capabilityKey",
    });
  }),
);

export function killswitchSummaryFromJSON(
  jsonString: string,
): SafeParseResult<KillswitchSummary, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => KillswitchSummary$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'KillswitchSummary' from JSON`,
  );
}
